module.exports = __webpack_public_path__ + "img/greenTick.23b3d292.svg";